import { useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { setActiveCampaignEmail, reloadPageForRouteChange, initializeReloadTracking } from '../utils/trackingHelper';

const RouteChangeTracker = () => {
  const location = useLocation();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    initializeReloadTracking();
  }, []);

  useEffect(() => {
    // Call setActiveCampaignEmail whenever the route changes and user is logged in
    if (user && user.email) {
      setActiveCampaignEmail(user.email);
    }

    const storedPath = sessionStorage.getItem('lastReloadedPath');
    if (storedPath !== location.pathname) {
      reloadPageForRouteChange(location.pathname);
    }
  }, [location.pathname, user]);

  return null;
};

export default RouteChangeTracker; 